import { getUserOrdersApiRequest } from '@guryou/api-client-gql';
import { execute } from '../actions/actionWrapper';
import { Action, basicReducer } from '../core';
export const GET_USER_ORDERS = {
  entity: 'GET_USER_ORDERS',
  action: Action.GET_MANY
};
export const getUserOrders = (userId, customerId) => async dispatch => execute(dispatch, () => getUserOrdersApiRequest(userId, customerId), GET_USER_ORDERS, false);
export const orderReducers = {
  userOrders: basicReducer(GET_USER_ORDERS)
};